import { DSCBCoupledPosts } from 'shared-definitions/types'
import { ApiContentBLockCoupledPostsList } from 'data-source/types.wp'
import { PLinkMapperOpts, pLinkMapper } from 'data-source/mappers/pLinkMapper'
import {
  OnePostWithAuthorMapperOpts,
  onePostWithAuthorMapper,
} from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'
import { onePostMapper } from 'data-source/mappers/onePostMapper'

type CoupledPostsProps = PLinkMapperOpts & OnePostWithAuthorMapperOpts

export function cbCoupledPosts(
  input: ApiContentBLockCoupledPostsList,
  opts: CoupledPostsProps
): DSCBCoupledPosts {
  return {
    resource: 'cb-coupled-posts',
    title: input.title,
    subtitle: input.subtitle,
    taxonomy: input.taxonomy,
    button: {
      label: input.button.label,
      pLink: pLinkMapper(input.button.link, opts),
    },
    posts: {
      ...paginationMapper(input.content),
      items: input.content.posts.map(i => onePostWithAuthorMapper(i, opts)),
    },
    secondary: input.secondary_posts.map(i => onePostMapper(i, opts)),
  }
}
